import { render, staticRenderFns } from "./SmallTopBigBottom.vue?vue&type=template&id=47fe5608"
import script from "./SmallTopBigBottom.vue?vue&type=script&lang=js"
export * from "./SmallTopBigBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports